import Vue from 'vue'
import App from './App.vue'
import './assets/styles/app.scss'
import httpClient from '@/services/httpClient'
import authService from '@/services/authService'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import VueMoment from 'vue-moment'
//import moment from 'moment-timezone'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import highchartsMore from 'highcharts/highcharts-more';
import solidgauge from 'highcharts/modules/solid-gauge'

highchartsMore(Highcharts);
solidgauge(Highcharts)

// Application constants
// ---------------------
import constants from "./js/constants";
import functions from "./js/functions";

Vue.config.productionTip = false

// Uses
// ----
Vue.use(functions);
Vue.use(VueMoment);
Vue.use(HighchartsVue)

// Prototypage
// -----------
Vue.prototype.$http = httpClient
Vue.prototype.$constants = constants
Vue.prototype.$functions = functions
Vue.prototype.$startWorker = function(task) {
  this.$root.$emit('startWorker', task)
}


// Gestion des actions sur changement de route
// -------------------------------------------
router.afterEach((to) => {  
  // Pages publiques (connexion, choix du mot de passe) : sans en-tête ni pied de page
  const isPublic = ['Login', 'ResetPassword'].includes(to.name)
  store.commit('setViewableHeader', !isPublic)
  store.commit('setViewableFooter', !isPublic)
})
//let es; // Initialisation vide pour éviter les erreurs;

// Instanciation de Vue
// --------------------
// Consultant (SEC-22) : consultation seule. isConsultant masque les actions dans les vues ;
// toute écriture qui passerait quand même est arrêtée ici (le serveur la refuse aussi, 403).
const isConsultant = () => {
  const profile = store.state.profile || {}
  return Number(profile.role) === constants.users.USER_ROLE_CONSULTANT && !profile.is_su
}
Vue.mixin({
  computed: {
    isConsultant: () => isConsultant()
  }
})
httpClient.interceptors.request.use(config => {
  const method = (config.method || 'get').toLowerCase()
  const allowed = ['get', 'options'].includes(method)
    || /^\/?(login|renewal|forgetpassword|passwordreset)/.test(config.url || '')
    || !!(config.data && config.data.old_password)
  if (!isConsultant() || allowed) return config
  window.dispatchEvent(new CustomEvent('readonly:blocked'))
  return Promise.reject({ readOnly: true, response: { status: 403 } })
})

var vm = new Vue({
  store,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')

window.addEventListener('readonly:blocked', () => vm.$emit('notify', 'Consultation seule : action non autorisée', 'warning', 'mdi-eye-outline'))

// Evenements applicatif
// ---------------------
vm.$root.$on('login', function() {
  authService.getProfile()
      .then(function(profile) {
            this.$vuetify.theme.dark = profile.is_dark_theme
            //vm.$store.commit('functionalities', profile.functions);
            this.$store.commit('setProfile', profile)

            this.$store.dispatch('initFiltersVehicle');
            this.$store.dispatch('initFiltersUser');

            this.$router.push('dashboard');

            functions.startSSEConnection(vm);

            // Run token renewal every 15 minutes
            let interval = 15 * 60 * 1000; // 15 minutes
            setInterval(function() {
              this.$store.dispatch('renewalToken')
                .then((token) => {
                   this.$root.$emit('tokenRenewed', token);
                });
            }.bind(this), interval);
      }.bind(this))
      .catch(error => {
          console.log(error)
  });
});

vm.$root.$on('tokenRenewed', function() { 
  functions.startSSEConnection(vm);
 });

vm.$root.$on('logout', function() {
  this.$store.dispatch('logout');
  this.$router.push('/');
});

window.addEventListener('auth:unauthorized', () => {
  vm.$root.$emit('logout');
});

vm.$root.$on('serverError', function(error) {
  console.log(error);
})

vm.$root.$on('startWorker', function(task) {
  if (typeof task !== 'function') return
  task()
});

